var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'uuid/v4'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/uuid/v4.js' implicitly has an 'any' type.
import uuid from "uuid/v4";
import { useFormContext } from "react-hook-form";
import { AcademicCalendarMultiSearch } from "../../AcademicCalendar/AcademicCalendarSearch";
import SearchField from "../../../Form/SearchField";
import AcademicCalendarService from "../../../../Services/AcademicCalendar.service";
import TranscriptCourseStatusDomainService from "../../../../Domain/TranscriptCourseStatus/TranscriptCourseStatus.service";
import CheckboxField from "../../../Form/CheckboxField";
import { CourseSectionMultiSearch } from "../../CourseSection/CourseSectionSearch";
import DepartmentService from "../../../../Services/Department.service";
import { CourseMultiSearch } from "../../Course/CourseSearch";
import CourseService from "../../../../Services/Course.service";
import CourseSectionService from "../../../../Services/CourseSection.service";
import { DepartmentMultiSearch } from "../../Department/DepartmentSearch";
export const WAIT_FOR_ENROLLMENT_GET_CRITERIA = (formState, { exportNodeId }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const PERSON_LOADER_DELEGATE_ID = uuid();
    const personLoaderDelegate = {
        id: PERSON_LOADER_DELEGATE_ID,
        type: "PersonLoader",
        criteria: {
            personId: {
                isReference: true,
                workflowNodeReferenceId: exportNodeId,
                propertyName: "studentId",
            },
        },
    };
    return {
        delegates: [personLoaderDelegate],
        criteria: {
            studentPersonId: {
                isReference: true,
                workflowNodeReferenceId: PERSON_LOADER_DELEGATE_ID,
                propertyName: "personId",
            },
            transcriptCourseStatusIds: {
                value: [TranscriptCourseStatusDomainService.RegisteredId],
                isReference: false,
            },
            academicCalendarIds: {
                value: (_b = (_a = formState.academicCalendars) === null || _a === void 0 ? void 0 : _a.map((data) => data.id)) !== null && _b !== void 0 ? _b : [],
                isReference: false,
            },
            departmentIds: {
                value: (_d = (_c = formState.departments) === null || _c === void 0 ? void 0 : _c.map((data) => data.id)) !== null && _d !== void 0 ? _d : [],
                isReference: false,
            },
            courseSectionIds: {
                value: (_f = (_e = formState.courseSections) === null || _e === void 0 ? void 0 : _e.map((data) => data.id)) !== null && _f !== void 0 ? _f : [],
                isReference: false,
            },
            courseIds: {
                value: (_h = (_g = formState.courses) === null || _g === void 0 ? void 0 : _g.map((data) => data.id)) !== null && _h !== void 0 ? _h : [],
                isReference: false,
            },
            considerHistory: {
                value: formState.considerHistory,
                isReference: false,
            },
        },
    };
};
export const WAIT_FOR_ENROLLMENT_GET_FORM_STATE = (criteria) => __awaiter(void 0, void 0, void 0, function* () {
    // quick helper function because I don't want to type this over and over.
    const getIfArrayHasItems = (arr, service) => {
        if (arr === null || arr === void 0 ? void 0 : arr.length) {
            return service(arr);
        }
        return Promise.resolve([]);
    };
    const [academicCalendars, departments, courses, courseSections] = yield Promise.all([
        getIfArrayHasItems(criteria.academicCalendarIds.value, (ids) => AcademicCalendarService.lookupSearch({
            ids,
        }).then((response) => response.data)),
        getIfArrayHasItems(criteria.departmentIds.value, (ids) => DepartmentService.search({
            ids,
        }).then((response) => response.data)),
        getIfArrayHasItems(criteria.courseIds.value, (ids) => CourseService.search({
            ids,
        }).then((response) => response.data)),
        getIfArrayHasItems(criteria.courseSectionIds.value, (ids) => CourseSectionService.search({
            ids,
        }).then((response) => response.data)),
    ]);
    const considerHistory = criteria.considerHistory.value;
    return {
        academicCalendars,
        departments,
        courses,
        courseSections,
        considerHistory,
    };
});
const WaitForEnrollmentWorkflowNodeDefinitionForm = ({ name, }) => {
    const { watch } = useFormContext();
    const courses = watch("courses");
    const academicCalendars = watch("academicCalendars");
    const [, _setCounter] = React.useState(0);
    const forceRerender = () => {
        _setCounter((c) => c + 1);
    };
    return (_jsxs(_Fragment, { children: [_jsx(SearchField, { label: "Term(s)", name: name + ".academicCalendars", as: (provided) => (_jsx(AcademicCalendarMultiSearch, Object.assign({ lookupModal: { isInModal: false }, noOptionsMessage: ({ inputValue }) => {
                        if ((inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) < 3) {
                            return "Please type at least 3 characters";
                        }
                        return "No Options";
                    }, minNumSearchCharacters: 3 }, provided))) }), _jsx(SearchField, { label: "Course(s)", name: name + ".courses", as: (provided) => (_jsx(CourseMultiSearch, Object.assign({ hasActiveCourseSections: true, onBlur: () => {
                        // Make sure we have the latest version of courses
                        forceRerender();
                    }, lookupModal: { isInModal: false }, noOptionsMessage: ({ inputValue }) => {
                        if ((inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) < 3) {
                            return "Please type at least 3 characters";
                        }
                        return "No Options";
                    }, minNumSearchCharacters: 3 }, provided))) }), _jsx(SearchField, { label: "Department(s)", name: name + ".departments", as: (provided) => (_jsx(DepartmentMultiSearch, Object.assign({ lookupModal: {
                        isInModal: false,
                    }, noOptionsMessage: ({ inputValue }) => {
                        if ((inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) < 3) {
                            return "Please type at least 3 characters";
                        }
                        return "No Options";
                    }, minNumSearchCharacters: 3 }, provided))) }), _jsx(SearchField, { label: "Course Section(s)", name: name + ".courseSections", as: (provided) => (_jsx(CourseSectionMultiSearch, Object.assign({ lookupModal: {
                        isInModal: false,
                        defaultCourses: courses,
                        defaultTerms: academicCalendars,
                    }, noOptionsMessage: ({ inputValue }) => {
                        if ((inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) < 3) {
                            return "Please type at least 3 characters";
                        }
                        return "No Options";
                    }, minNumSearchCharacters: 3 }, provided))) }), _jsx(CheckboxField, { label: "Consider Existing Data", name: name + ".considerHistory", helpText: "Leaving this box unchecked will only consider enrollments that have been submitted since the last time this automation was created." })] }));
};
export default WaitForEnrollmentWorkflowNodeDefinitionForm;
